<ng-container *ngIf="orderDetail?.orderNumber && orderDetail?.errorCard; else contentCards">

	<mat-accordion>
		<mat-expansion-panel [expanded]="expandMROPanel">
			<mat-expansion-panel-header>
				<h3 class="most-recent-order-header">Order #{{orderDetail?.orderNumber}}</h3>
				<p class="most-recent-order-info">{{orderDetail?.placedDate | date: 'MMMM d, y' }} | {{orderDetail?.grandTotal | currency}}</p>
			</mat-expansion-panel-header>
			<div class="purchase-cell">
				<div class="purchase-cell-info">
					<hmf-alert-banner
						messageType="warning"
						[messageBody]="'Apologies, we\'re experiencing issues loading this order. Please try again later.'"
					/>
				</div>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</ng-container>

<ng-template #contentCards>
<!-- In-Store Orders -->
<ng-container *ngIf="inStorePurchaseData">
	<mat-accordion>
		<mat-expansion-panel [expanded]="expandMROPanel">
			<mat-expansion-panel-header *ngIf="!inStoreDetailsEnabled">
				<h3 class="most-recent-order-header">Order #{{inStorePurchaseData?.purchaseNumber}}</h3>
				<p class="most-recent-order-info">{{inStorePurchaseData?.purchaseDate | date: 'MMMM d, y' }} | {{inStorePurchaseData?.grandTotal | currency}}</p>
			</mat-expansion-panel-header>
			<mat-expansion-panel-header *ngIf="inStoreDetailsEnabled" (click)="analyticsClick(inStorePurchaseData?.orderNumber.toString(), 'click', 'PanelHeaderClicked')">
				<h3 class="most-recent-order-header">Order #<a href="/MyAccount/OrderDetail/{{inStorePurchaseData?.orderNumber}}" (click)="analyticsClick(inStorePurchaseData?.orderNumber.toString(), 'click', 'OrderNumberClick')">{{inStorePurchaseData?.orderNumber}}</a></h3>
				<p class="most-recent-order-info">{{inStorePurchaseData?.placedDate | date: 'MMMM d, y' }} | {{inStorePurchaseData?.grandTotal | currency}} | {{itemTotal}} item<span *ngIf="itemTotal !== 1">s</span></p>
			</mat-expansion-panel-header>
			<div class="purchase-cell">
				<div class="purchase-cell-images">
					<ng-container *ngFor="let item of inStorePurchaseData?.items; index as i;"><img #inStoreImage loading="lazy" class="purchase-items-image" (error)="handleImageError(inStoreImage, item.imageIdentifier)" src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" *ngIf="i <= 2" [alt]="item.name"></ng-container>
				</div>

				<div class="purchase-cell-info hmf-mt-s-xs hmf-mt-m-0">
					<h2 class="card-header">
						<homefield-icon name="building-store-dsg-alt" class="fulfilment-icon" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
						<span *ngIf="inStorePurchaseData?.grandTotal > 0; else returnOrder" class="icon-text-color">Store Purchase</span>
						<homefield-icon name="sign-check" class="sign-check-icon" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
						<ng-template #returnOrder class="icon-text-color">Returned In-Store</ng-template>
					</h2>
					<div class="no-margin" [ngSwitch]="inStorePurchaseData?.storeChain">
						<p *ngSwitchCase="'dsg'" class="hmf-subheader-bold-s">DICK'S - {{toTitleCase(inStorePurchaseData?.storeInfo.storeName)}}</p>
						<p *ngSwitchCase="'gg'" class="hmf-subheader-bold-s">Golf Galaxy - {{toTitleCase(inStorePurchaseData?.storeInfo.storeName)}}</p>
						<p *ngSwitchCase="'ggg'" class="hmf-subheader-bold-s">Going Going Gone! - {{toTitleCase(inStorePurchaseData?.storeInfo.storeName)}}</p>
						<p *ngSwitchCase="'pl'" class="hmf-subheader-bold-s">Public Lands - {{toTitleCase(inStorePurchaseData?.storeInfo.storeName)}}</p>
						<p class="hmf-body-s">{{toTitleCase(inStorePurchaseData?.storeInfo.streetAddress1)}}, {{toTitleCase(inStorePurchaseData?.storeInfo.city)}}, {{inStorePurchaseData?.storeInfo.state}}, {{inStorePurchaseData?.storeInfo.zipCode}}</p>
					</div>
				</div>
			</div>
			<hr />
			<span *ngIf="inStoreDetailsEnabled">
				<a homefield-button variant="primary" [routerLink]="'/MyAccount/OrderDetail/' + inStorePurchaseData?.orderNumber" class="purchase-details-button" (click)="analyticsClick(inStorePurchaseData?.orderNumber.toString(), 'click', 'ViewInStoreOrderDetailsClick')">View Order Details</a>
			</span>
		</mat-expansion-panel>
	</mat-accordion>
</ng-container>

<!-- Online Orders -->
<ng-container *ngIf="purchaseType && purchaseType === 1 && orderDetailLoaded">
	<mat-accordion>
		<mat-expansion-panel [expanded]="expandMROPanel">
			<mat-expansion-panel-header (click)="analyticsClick(orderDetail?.orderNumber.toString(), 'click', 'PanelHeaderClicked')">
				<h3 class="most-recent-order-header">Order #<a href="/MyAccount/OrderDetail/{{orderDetail?.orderNumber}}" (click)="analyticsClick(orderDetail?.orderNumber?.toString(), 'click', 'OrderNumberClick')">{{orderDetail?.orderNumber}}</a></h3>
				<p class="most-recent-order-info">{{orderDetail?.placedDate | date: 'MMMM d, y' }} | {{orderDetail?.grandTotal | currency}} | {{itemTotal}} item<span *ngIf="itemTotal !== 1">s</span></p>
			</mat-expansion-panel-header>
			<!-- SHIPPING ORDERS -->
			<div class="purchase-cell" *ngFor="let group of sortedShippingGroups">
				<div class="purchase-cell-images">
					<ng-container  *ngFor="let item of group.items; index as i;"><img #shippingImage loading="lazy" class="purchase-items-image" (error)="handleImageError(shippingImage, item.imageIdentifier)" src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" *ngIf="i <= 2" [alt]="item.name"></ng-container>
				</div>
				<div class="purchase-cell-info hmf-mt-s-xs hmf-mt-m-0">
					<h2 class="card-header">
						<homefield-icon name="vehicle-shipping" class="fulfilment-icon" fill="var(--hmf-primary600)"></homefield-icon>
						<span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode === 'Order Placed' && !group.groupEstimatedDelivery" class="icon-text-color">Order Placed</span>
						<span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode !== 'Order Placed' && group.groupStatusCode !== 'Shipped'" class="icon-text-color">Preparing</span>
						<span *ngIf="group.groupTrackingStatus !== 'Delivered' && group.groupStatusCode === 'Shipped'" class="icon-text-color">Shipped</span>
						<span *ngIf="group.groupTrackingStatus === 'Delivered'" class="icon-text-color">Delivered</span>
						<homefield-icon name="sign-check" class="sign-check-icon" fill="var(--hmf-primary600)"></homefield-icon>
					</h2>
					<p class="delivery-window-message hmf-body-bold-s" *ngIf="group.groupStatusCode !== 'Order Placed' && group.groupTrackingStatus !== 'Delivered' && group.groupEstimatedDelivery">Est. Delivery:
						<span class="start-date-range" *ngIf="group.groupStartEstimatedDelivery">{{group.groupStartEstimatedDelivery | date: 'EE, MMM d'}}&nbsp;&ndash;&nbsp;</span>
						<span class="end-date-range">{{group.groupEstimatedDelivery | date: 'EE, MMM d'}}</span>
					</p>
					<p class="icon-text-color" *ngIf="group.groupTrackingStatus === 'Delivered'">Delivered On: {{group.groupEstimatedDelivery | date: 'EE, MMM d'}}</p>
					<p class="tracking-info-noTracking" *ngIf="group.groupTrackingNumber === 'NO_TRACKING_AVAILABLE_YET'; else trackingStatus">Tracking available when shipped</p>
					<ng-template #trackingStatus>
						<p class="tracking-info-hasTracking">Tracking: <a class="tracking-info-link" href="{{group.groupTrackingUrl}}" (click)="analyticsClick(orderDetail.orderNumber.toString(), 'click', 'OrderTrackingNumberClicked')">{{group.groupTrackingNumber}}</a></p>
					</ng-template>
					<my-account-components-progress-tracker [groupStatusPosition]="group.groupStatusCode" [fulfilmentType]="'shipping'"></my-account-components-progress-tracker>
				</div>
			</div>

			<!-- CANCELLED SHIPPING -->
			<div class="purchase-cell" *ngIf="cancelledShippingItems?.length > 0">
				<div class="purchase-cell-images">
					<ng-container  *ngFor="let item of cancelledShippingItems; index as i;">
						<img #cancelledShippingImage loading="lazy" *ngIf="i <= 2" class="purchase-items-image"
							(error)="handleImageError(cancelledShippingImage, item.imageIdentifier)"
							src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" [alt]="item.name">
					</ng-container>
				</div>
				<div class="purchase-cell-info hmf-mt-s-xs hmf-mt-m-0">
					<h2 class="card-header">
						<homefield-icon name="sign-circled-cancel-filled" class="fulfilment-icon" fill="var(--hmf-primary600)"></homefield-icon>
						<span class="icon-text-color">Cancelled</span>
					</h2>
				</div>
			</div>

			<!-- BOPIS ORDERS -->
			<div class="purchase-cell" *ngFor="let group of sortedActiveBopisItems">
				<div class="purchase-cell-images">
					<ng-container  *ngFor="let item of group.items"><img #bopisImage loading="lazy" class="purchase-items-image" (error)="handleImageError(bopisImage, item.imageIdentifier)" src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" [alt]="item.name"></ng-container>
				</div>
				<div class="purchase-cell-info hmf-mt-s-xs hmf-mt-m-0">
					<h2 class="card-header icon-text-color" [ngSwitch]="group.status">
						<homefield-icon name="building-store-dsg-alt" class="fulfilment-icon" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
						<span *ngSwitchCase= "'Order Placed'">Order Placed</span>
						<span *ngSwitchCase= "'In Process'">Preparing Pickup</span>
						<span *ngSwitchCase= "'Ready For Pickup'">Ready for pickup</span>
						<span *ngSwitchCase= "'Picked Up'">Picked up</span>
						<homefield-icon name="sign-check" class="sign-check-icon" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
					</h2>
					<div *ngFor="let item of group.items" [ngSwitch]="group.locationChain">
                        <span *ngSwitchCase="'dsg'" class="hmf-subheader-bold-m">DICK'S - {{item.shippingRecipient.address.address2}}</span>
                        <span *ngSwitchCase="'pl'" class="hmf-subheader-bold-m">Public Lands - {{item.shippingRecipient.address.address2}}</span>
                        <span *ngSwitchCase="'gg'" class="hmf-subheader-bold-m">Golf Galaxy - {{item.shippingRecipient.address.address2}}</span>
                        <span *ngSwitchCase="'ggg'" class="hmf-subheader-bold-m">Going Going Gone! - {{item.shippingRecipient.address.address2}}</span><br/>
                        <span>{{toTitleCase(item.shippingRecipient.address.address3)}}, {{toTitleCase(item.shippingRecipient.address.city)}}, {{item.shippingRecipient.address.state}}, {{item.shippingRecipient.address.postalCode}}</span>
                    </div>
					<p *ngIf="group.locationAddress !== 'USE_NO_ADDRESS'" [ngSwitch]="group.locationChain">
						<span *ngSwitchCase="'dsg'"><homefield-icon height="20" width="140" name="dsg-store-pickup" class="pickup-icon-store" alt="Dick's Sporting Goods" fill="var(--hmf-primary600)"></homefield-icon></span>
						<span *ngSwitchCase="'gg'"><homefield-icon height="20" width="140" name="gg-store-pickup" class="pickup-icon-store" alt="Golf Galaxy" fill="var(--hmf-primary600)"></homefield-icon></span>
						<span *ngSwitchCase="'ggg'"><homefield-icon height="20" width="140" name="ggg-store-pickup" class="pickup-icon-store" alt="Going Going Gone" fill="var(--hmf-primary600)"></homefield-icon></span>
						<span *ngSwitchCase="'pl'"><homefield-icon height="20" width="140" name="pl-store-pickup" class="pickup-icon-store" alt="Public Lands" fill="var(--hmf-primary600)"></homefield-icon></span>
						<br/>
					{{group.locationAddress}}</p>
					<my-account-components-progress-tracker [groupStatusPosition]="group.status" [fulfilmentType]="'bopis'"></my-account-components-progress-tracker>
					<p *ngIf="(group.status === 'In Process' || group.status === 'Order Placed')" class="order-notification-text">We'll send you an email when it's ready for pickup.</p>
				</div>
				<!-- BOPIS READY TO PICKUP -->
				<div class="purchase-cell-pickup-ready" *ngIf="group.status ==='Ready For Pickup'">
					<my-account-components-checkin-button #checkinComponent [orderDetail]="orderDetail" [zipCode]="orderZip" [resetCheckIn]="resetCheckIn"></my-account-components-checkin-button>
				</div>
			</div>

			<!-- CANCELLED BOPIS -->
			<div class="purchase-cell" *ngIf="cancelledBopisItems.length > 0">
				<div class="purchase-cell-images">
					<ng-container *ngFor="let item of cancelledBopisItems; index as i;">
						<img #cancelledBopisImage loading="lazy" *ngIf="i <= 2" class="purchase-items-image" (error)="handleImageError(cancelledBopisImage, item.imageIdentifier)" src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" [alt]="item.name">
					</ng-container>
				</div>
				<div class="purchase-cell-info hmf-mt-s-xs hmf-mt-m-0">
					<h2 class="card-header">
						<homefield-icon name="sign-circled-cancel-filled" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
						<span class="icon-text-color">Cancelled</span>
					</h2>
				</div>
			</div>

			<!-- SAME DAY DELIVERY-->
			<div class="purchase-cell" *ngFor="let group of sortedSameDayShippingGroups">
				<div class="purchase-cell-images">
	  				<ng-container *ngFor="let item of group.items;"><img #sameDayImage loading="lazy" class="purchase-items-image" (error)="handleImageError(sameDayImage, item.imageIdentifier)" src="https://images.dickssportinggoods.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" [alt]="item.name"></ng-container>
				</div>
				<div class="purchase-cell-info hmf-mt-s-xs hmf-mt-m-0">
	  				<h2 class="card-header icon-text-color">
						<div class="hmf-display-flex hmf-flex-m-row hmf-align-items-center pb-2">
							<homefield-icon name="order-delivery" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
							<div class="pl-2">{{ group.groupHeaderText }}</div>
							<homefield-icon name="sign-check" class="sign-check-icon" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
						</div>
					</h2>
					<div>
						<ng-container *ngIf="group.groupTrackingNumber === 'NO_TRACKING_AVAILABLE_YET'">
							<span class="delivery-window-message hmf-body-bold-s">Est. Delivery: {{group.groupEstimatedDelivery | date: 'EE, MMM d'}}</span><br/>
							<span class="icon-text-color">(delivery from 4-7pm)</span><br/>
							<span>Tracking available once picked up by Dasher.</span>
						</ng-container>
						<ng-container *ngIf="group.groupTrackingNumber !== 'NO_TRACKING_AVAILABLE_YET'">
							<p class="font-text-weight-bold">Tracking: <a [href]="group.groupTrackingUrl">{{ group.groupDistributionOrder }}</a></p>
						</ng-container>
					</div>
	  				<my-account-components-progress-tracker *ngIf="group.groupHeaderText !== 'Undeliverable'" [groupStatusPosition]="group.groupStatusCode" [fulfilmentType]="'sameday'"></my-account-components-progress-tracker>
				</div>
  			</div>

			<!-- CANCELLED SAME DAY DELIVERY -->
			<div class="purchase-cell" *ngIf="cancelledSameDayDeliveryItems.length > 0">
			  <div class="purchase-cell-images">
				  <ng-container *ngFor="let item of cancelledSameDayDeliveryItems; index as i;">
					  <img #cancelledSameDayImage loading="lazy" *ngIf="i <= 2" class="purchase-items-image" (error)="handleImageError(cancelledSameDayImage, item.imageIdentifier)" src="https://dks.scene7.com/is/image/dkscdn/{{item.imageIdentifier}}/?$DSG_ShoppingCart$" [alt]="item.name">
					</ng-container>
				</div>
				<div class="purchase-cell-info hmf-mt-s-xs hmf-mt-m-0">
					<h2 class="card-header">
						<homefield-icon name="sign-circled-cancel-filled" aria-hidden="true" fill="var(--hmf-primary600)"></homefield-icon>
						<span class="icon-text-color">Cancelled</span>
					</h2>
				</div>
			</div>
			<hr />

			<a homefield-button variant="primary" [routerLink]="'/MyAccount/OrderDetail/' + orderDetail?.orderNumber" class="purchase-details-button" (click)="analyticsClick(orderDetail?.orderNumber.toString(), 'click', 'ViewInStoreOrderDetailsClick')">View Order Details</a>
		</mat-expansion-panel>
	</mat-accordion>
</ng-container>
</ng-template>
